import React from 'react';
import { bool, func, shape, string } from 'prop-types';
import { compose } from 'redux';
import classNames from 'classnames';
import { Form as FinalForm } from 'react-final-form';
import arrayMutators from 'final-form-arrays';
import { intlShape, injectIntl, FormattedMessage } from '../../util/reactIntl';
import { nonEmptyArray } from '../../util/validators';

import { propTypes } from '../../util/types';
import config from '../../config';
import { Button, Form, FieldCheckboxGroup, FieldCheckboxDoubleGroup } from '../../components';

import css from './EditListingFeaturesForm.css';

const EditListingFeaturesFormComponent = props => (
  <FinalForm
    {...props}
    mutators={{ ...arrayMutators }}
    render={formRenderProps => {
      const {
        intl,
        disabled,
        invalid,
        ready,
        rootClassName,
        className,
        handleSubmit,
        pristine,
        saveActionMsg,
        updated,
        updateInProgress,
        fetchErrors,
      } = formRenderProps;

      const amenitiesRequiredMessage = intl.formatMessage({
        id: 'EditListingFeaturesForm.amenitiesRequired',
      });
      const minAmenitiesLengthMessage = nonEmptyArray(amenitiesRequiredMessage)

      const flooringTypesRequiredMessage = intl.formatMessage({
        id: 'EditListingFeaturesForm.flooringTypesRequired',
      });
      const minFlooringTypesLengthMessage = nonEmptyArray(flooringTypesRequiredMessage)

      const parkingRequiredMessage = intl.formatMessage({
        id: 'EditListingFeaturesForm.parkingRequired',
      });
      const minParkingLengthMessage = nonEmptyArray(parkingRequiredMessage)

      const classes = classNames(rootClassName || css.root, className);
      const submitReady = (updated && pristine) || ready;
      const submitInProgress = updateInProgress;
      const submitDisabled = invalid || disabled || submitInProgress;

      const { updateListingError, showListingsError } = fetchErrors || {};
      const errorMessage = updateListingError ? (
        <p className={css.error}>
          <FormattedMessage id="EditListingFeaturesForm.updateFailed" />
        </p>
      ) : null;

      const errorMessageShowListing = showListingsError ? (
        <p className={css.error}>
          <FormattedMessage id="EditListingFeaturesForm.showListingFailed" />
        </p>
      ) : null;

      return (
        <Form className={classes} onSubmit={handleSubmit}>
          {errorMessage}
          {errorMessageShowListing}

          <FieldCheckboxDoubleGroup
            rootClassName={css.group}
            className={css.field}
            textClassName={css.featureItem}
            // listClassName={css.list}
            id='amenities'
            name='amenities'
            twoColumns={true}
            label={<FormattedMessage id="EditListingFeaturesForm.amenitiesTitle" />}
            placeholder={<FormattedMessage id="EditListingFeaturesForm.amenitiesPlaceholder" />}
            label2={<FormattedMessage id="EditListingFeaturesForm.healthRelatedTitle" />}
            placeholder2={<FormattedMessage id="EditListingFeaturesForm.healthRelatedPlaceholder" />}
            options={config.custom.amenities}
            options2={config.custom.healthRelated}
            validate={minAmenitiesLengthMessage} />

          <FieldCheckboxGroup
            rootClassName={css.group}
            className={css.field}
            textClassName={css.featureItem}
            // listClassName={css.list}
            id='flooringTypes'
            name='flooringTypes'
            twoColumns={true}
            label={<FormattedMessage id="EditListingFeaturesForm.flooringTitle" />}
            placeholder={<FormattedMessage id="EditListingFeaturesForm.flooringPlaceholder" />}
            options={config.custom.flooringTypes}
            validate={minFlooringTypesLengthMessage} />

          <FieldCheckboxGroup
            rootClassName={css.group}
            className={css.field}
            textClassName={css.featureItem}
            // listClassName={css.list}
            id='parking'
            name='parking'
            twoColumns={true}
            label={<FormattedMessage id="EditListingFeaturesForm.parkingTitle" />}
            placeholder={<FormattedMessage id="EditListingFeaturesForm.parkingPlaceholder" />}
            options={config.custom.parking}
            validate={minParkingLengthMessage} />

          <Button
            className={css.submitButton}
            type="submit"
            inProgress={submitInProgress}
            disabled={submitDisabled}
            ready={submitReady}
          >
            {saveActionMsg}
          </Button>
        </Form>
      );
    }}
  />
);

EditListingFeaturesFormComponent.defaultProps = {
  rootClassName: null,
  className: null,
  fetchErrors: null,
};

EditListingFeaturesFormComponent.propTypes = {
  intl: intlShape.isRequired,
  rootClassName: string,
  className: string,
  onSubmit: func.isRequired,
  saveActionMsg: string.isRequired,
  disabled: bool.isRequired,
  ready: bool.isRequired,
  updated: bool.isRequired,
  updateInProgress: bool.isRequired,
  fetchErrors: shape({
    showListingsError: propTypes.error,
    updateListingError: propTypes.error,
  }),
};

export default compose(injectIntl)(EditListingFeaturesFormComponent);
